'use client'

import { useEffect, useState } from "react";
import { initializeMsal, msalInstance } from "../msal/msal";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";

export default function MsalAuthProvider({ children }) {
    const [msalReady, setMsalReady] = useState(false);

    useEffect(() => {
        async function initMsal() {
            await initializeMsal();
            setMsalReady(true);
        }

        initMsal();
    }, []);

    if (!msalReady) {
        // return <div>Loading Authentication...</div>;
    }
    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    );
};

